<div class="conversation-list">
	<div class="conversation-list-header">
		<md-header size="sm">Conversations</md-header>
		<button type="button" md-button-brand class="new-chat-button" (click)="createNewConversation()">
			<md-icon [icon]="'untitled-ui/general/plus'"></md-icon>
			New Chat
		</button>
	</div>

	<div class="conversations-container">
		@if (conversations().length === 0) {
			<div class="no-conversations">
				<span>No conversations yet</span>
			</div>
		} @else {
			@for (conversation of conversations(); track conversation.id) {
				<div class="conversation-item" [class.active]="conversation.id === activeConversationId()" (click)="selectConversation(conversation.id)">
					<div class="conversation-avatar">
						<md-icon [icon]="'untitled-ui/communication/message-chat-circle'"></md-icon>
					</div>
					<div class="conversation-content">
						<div class="conversation-header">
							<span class="conversation-title">{{ conversation.title }}</span>
							<span class="conversation-date">{{ getFormattedDate(conversation.lastMessageDate) }}</span>
						</div>
						<div class="conversation-preview">
							<span class="last-message">{{ conversation.lastMessage }}</span>
							@if (conversation.unreadCount > 0) {
								<md-tag>
									{{ conversation.unreadCount }}
								</md-tag>
							}
						</div>
					</div>
				</div>
			}
		}
	</div>
</div>
